// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Secure CV
 * Service Secure CV
 * Version: v.0.1.0
 */import { DeepfakeState } from './DeepfakeState';
import { NullFilter } from './NullFilter';

export const DeepfakeFilter = {...DeepfakeState,...NullFilter,} as const
export type DeepfakeFilter = typeof DeepfakeFilter[keyof typeof DeepfakeFilter];
